import React, { useState } from 'react'
import { IoIosArrowForward } from "react-icons/io";
import play_logo from './components/icon/play-logo.svg';
import VerticalCarousel from './components/VerticalCarousel';
import { AnimatedSectionFromBelow } from './components/animation/animateElement'
import { redirectApp } from '../core/utils/helper'
import VideoModal from './components/VideoModal'
import { WandSparkles } from 'lucide-react'

const IndexHome1 = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleWatchDemo = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="min-h-[60vh] max-w-480:min-h-0 max-w-430:min-h-0 max-h-900:min-h-0 max-hw-1280-720:min-h-0 flex flex-col items-center justify-center bg-white relative overflow-x-hidden px-4 sm:px-6 py-6 sm:py-8 pb-10 max-h-900:py-5 max-h-900:pb-8 max-hw-1280-720:py-4 max-hw-1280-720:pb-6">
      <AnimatedSectionFromBelow delay={0.7}>
      <img
        src="/themes/basilisk/dots.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-60 pointer-events-none select-none"
      />
      </AnimatedSectionFromBelow>
      <div className="relative z-10 flex flex-col items-center sm:max-w-none w-full">
        <AnimatedSectionFromBelow delay={0.7}>
        <div className="mb-10 mt-2 sm:mt-0 sm:mb-6 max-h-900:mb-4 max-hw-1280-720:mb-3 z-20">
          <div className="inline-flex items-center gap-1.5 !leading-[15px] font-semibold border border-[#278DEC] text-xs px-[10px] py-1 sm:py-1 rounded-full shadow-sm font-inter">
            <WandSparkles className="w-3.5 h-3.5" />
            AI for Everyday Tasks
          </div>
        </div>
        </AnimatedSectionFromBelow>
        <AnimatedSectionFromBelow delay={0.2}>
          <h1 className="text-[1.8rem] sm:text-4xl md:text-6xl font-bold text-center text-gray-900 mb-2 max-h-900:mb-1 max-hw-1280-720:mb-1 leading-tight max-h-900:leading-snug font-inter overflow-visible">
              Your <span id='gradient-header' className="bg-gradient-to-r from-[#2874FA] to-[#22A4FF] bg-clip-text text-transparent">All-in-one</span> AI Assistant<br />
              <VerticalCarousel />
          </h1>
        </AnimatedSectionFromBelow>
        <AnimatedSectionFromBelow delay={0.3}>
          <div className='flex flex-col items-center justify-center'>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-2 w-full mx-auto sm:w-auto max-w-[360px] max-w-480:max-w-[480px] max-w-430:max-w-[360px] sm:max-w-none">  
            </div>
            <p className="text-black/75 text-center max-w-[400px] max-w-430:max-w-[400px] max-w-480:max-w-[480px] sm:max-w-[46rem] mb-8 sm:mb-8 max-h-900:mb-4 max-hw-1280-720:mb-4 max-h-900:leading-snug lg:text-[20px] text-[16px] leading-relaxed">
              AI-PRO is an all-in-one AI platform that combines chat, image generation, video generation, audio generation, document assistance, and creative tools 
              in one seamless workspace.
            </p>
            <div className="flex lg:gap-4 gap-[10px] mt-2 max-w-480:mb-8 max-h-900:mt-1 max-h-900:mb-2 max-hw-1280-720:mb-3">
              <button  
              onClick={(e) => redirectApp(e, 'registration')}
              className="flex items-center justify-center text-base sm:text-lg bg-[#3073D5] hover:bg-[#2590EE] text-white px-[26px] pr-[16px] py-[10px] sm:py-[0.55rem] rounded-full hover:border-[#2393F1] transition"
              >
                Start Now <IoIosArrowForward className="ml-1 text-base sm:text-lg" />
              </button>
              <button 
                onClick={handleWatchDemo}
                className="flex items-center justify-center text-base bg-white border border-[#3073D5] text-[#3073D5] sm:text-lg px-[14px] pr-[10px] py-[10px] sm:py-[0.55rem] rounded-full shadow hover:bg-[#2393F1] hover:border-[#2393F1] hover:text-white transition"
              >
                Watch Demo <img src={play_logo} alt="Play Logo" className="ml-1" />
              </button>
            </div>
          </div>
        </AnimatedSectionFromBelow>
      </div>
      <VideoModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  )
}

export default IndexHome1